// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".LanguageSwitcherModal-cls1__e6d043b6dbeaca187c20{/*!*/}.LanguageSwitcherModal-cls2___a48adcc3a3ebfc0b063{display:flex;flex-direction:column;align-items:center;grid-gap:16px;gap:16px;padding-bottom:8px}@media(min-width: 768px){.LanguageSwitcherModal-cls2___a48adcc3a3ebfc0b063{flex-direction:row;justify-content:center}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "LanguageSwitcherModal-cls1__e6d043b6dbeaca187c20",
	"cls2": "LanguageSwitcherModal-cls2___a48adcc3a3ebfc0b063 LanguageSwitcherModal-cls1__e6d043b6dbeaca187c20"
};
export default ___CSS_LOADER_EXPORT___;
